(function() {
    let data = (app || {}).data || {}
    let trackingData = data['tracking-data'] || {}
    let metaData = trackingData.Metadata || {}
    let pageLoad = trackingData.IsPageLoad === true 

    window.CsnInsights = window.CsnInsights || {}
    window.CsnInsights.metaData = metaData || {}
    window.CsnInsights.PageLoadEventValue = trackingData.PageLoadEventValue;

    window.CsnInsights.variantTest = window.CsnInsights.variantTest || {}

    window.CsnInsights.variantTest = trackingData.variantTest

    if (!pageLoad)
        window.CsnInsights.fireOnLoad = false

    if (trackingData.memberTrackingId && trackingData.memberTrackingId.length > 0)
        window.CsnInsights.memberTrackingId = trackingData.memberTrackingId

    if (app.disableSendPageView !== true && window.CsnInsightsEventTracker && window.CsnInsights) {
        window.CsnInsightsEventTracker.sendPageView(window.CsnInsights.metaData)
    }
})()
